// removed by extract-text-webpack-plugin
module.exports = {"headerWrapper":"headerWrapper--3cNWK","header":"header--G9Hr5","backgroundImageWrapper":"backgroundImageWrapper--I5wn_","info":"info--1W5WK","venue":"venue--1ckco","socialWrapper":"socialWrapper--31evU","social":"social--2i15C","separator":"separator--1SWjp","logo":"logo--3RwBa"};


//////////////////
// WEBPACK FOOTER
// ./components/Header/styles.css
// module id = 966
// module chunks = 2